import 'antd/dist/antd.min.css'
import React, { useMemo } from 'react'
import { BrowserRouter, Routes } from 'react-router-dom'
import styled from 'styled-components'

import { ACThemeProvider } from 'admin-web-ui'
import { flattenRoutes } from 'admin-web-utils'
import { buildRoutes } from '../../routes'
import { useAppContext } from './AppContext'
import { GlobalStyle } from './global-style'
import { getAppRoutes } from './routes'

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  min-width: 300px;
  display: flex;
  flex-direction: column;
`

export const App: React.FC = () => {
  const { cognitoUser } = useAppContext()

  const appRoutes = useMemo(() => {
    const routes = getAppRoutes()
    const flatRoutes = flattenRoutes([routes])
    const builtRoutes = buildRoutes({
      routes: flatRoutes,
      authGroups: cognitoUser ? [] : undefined,
    })

    return builtRoutes
  }, [cognitoUser])

  return (
    <ACThemeProvider>
      <GlobalStyle />
      <Container>
        <BrowserRouter>
          <Routes>{appRoutes}</Routes>
        </BrowserRouter>
      </Container>
    </ACThemeProvider>
  )
}
